<div class="toast-stack" aria-live="polite" aria-atomic="true">
  <div
    *ngFor="let t of svc.toasts()"
    class="toast"
    [class.toast-success]="t.tone === 'success'"
    [class.toast-error]="t.tone === 'error'"
    [class.toast-info]="t.tone === 'info'"
    role="status"
  >
    <div class="toast-body">
      <strong *ngIf="t.title">{{ t.title }}</strong>
      <span>{{ t.message }}</span>
    </div>
    <button class="toast-x" type="button" (click)="svc.dismiss(t.id)" aria-label="Dismiss">×</button>
  </div>
</div>
